import React, { useState } from "react";
import PropTypes from "prop-types";
import Progress from "./Progress";

const ResourceSection = ({ category, children, responseId, status, changeProgressStatus, hasTaxonomies, signedIn }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleCollapsed = () => {
    setIsCollapsed((prev) => !prev);
  };

  const collapserDirection = isCollapsed ? "down" : "up";

  return (
    <React.Fragment>
      <div className="categoryHeading">
        <h4>{category}</h4>
        <div className="status-collapser">
          {hasTaxonomies && signedIn && (
            <Progress
              status={status}
              responseId={responseId}
              changeProgressStatus={changeProgressStatus}
              showSelectedValueOnly={isCollapsed}
            />
          )}
          <div onClick={toggleCollapsed} className={`collapser ${collapserDirection}`}></div>
        </div>
      </div>
      {!isCollapsed && children}
      <hr className="category-separator" />
    </React.Fragment>
  );
};

ResourceSection.propTypes = {
  category: PropTypes.string,
  children: PropTypes.element.isRequired,
  responseId: PropTypes.number,
  status: PropTypes.string,
  changeProgressStatus: PropTypes.func,
  hasTaxonomies: PropTypes.bool,
  signedIn: PropTypes.bool,
};

export default ResourceSection;
